export enum FormattedInputEnum {
  mail = 'Mail',
  phone = 'Phone',
  url = 'URL',
}
